import { connect } from 'react-redux';
import config from '../../config';
import TickerComponent from './TickerComponent';
import { instrumentSelectorInstruments } from '@alphapoint/apex-web/lib/redux/selectors/instrumentPositionSelectors';

const mapStateToProps = (state) => {
  const { level1 } = state.apexCore;
  const { manifest } = state.productManifest;

  const instruments = instrumentSelectorInstruments(state);

  return {
    icons: manifest,
    instruments,
    level1,
    show24HrPxChange: config.TickerData.show24HrPxChange,
    show24HrVolume: config.TickerData.show24HrVolume,
  };
};

export default connect(mapStateToProps, null)(TickerComponent);
